export type PassReason = 'NOT_A_FIT' | 'TOO_EARLY' | 'SMALL_TRACTION' | 'NOT_DEPLOYING'

/**
 * The one "Follow instead" line a pass may show. Written words win over any reason (Not a fit included), then
 * Too early and Small traction; Not a fit and Not investing now alone show none. Never more than one line.
 */
export function passOfferKey(
  reason: PassReason,
  lookAgainWhen: string
): 'written' | 'tooEarly' | 'traction' | null {
  if (lookAgainWhen.trim() !== '') return 'written'
  if (reason === 'TOO_EARLY') return 'tooEarly'
  if (reason === 'SMALL_TRACTION') return 'traction'
  return null
}
